import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import UsersList from "./usersList";
import CoreCommittee from "./coreCommittee";

type TabKey = "users" | "coreCommittee";

const TAB_LABELS: Record<TabKey, string> = {
  users: "Users",
  coreCommittee: "Core Committee",
};

const UserManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("users");

  const TabContent = useMemo(
    () => ({
      users: <UsersList />,
      coreCommittee: <CoreCommittee />,
    }),
    []
  );

  return (
    <div>
      <section className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-xl font-semibold text-grease-100 tracking-tight">User Management</h1>

        <nav className="flex flex-wrap items-center text-sm text-lightgray-200 gap-x-2 gap-y-1 mt-1">
          <span className="st-dashboard text-lightgray-200 text-sm" aria-hidden="true" />
          <Link to="/admin/dashboard" className="hover:text-royalblue-100 transition-colors duration-150">
            Dashboard
          </Link>
          <span className="st-arrow-right text-lightgray-200 text-xs" aria-hidden="true" />
          <span className="text-royalblue-100 font-medium">User Management</span>
        </nav>
      </section>

      <section className="mt-6">
        <div className="flex items-center gap-2 mx-auto my-4 p-2 bg-blue-100 rounded-full w-max">
          {(["users", "coreCommittee"] as const).map((tab) => (
            <button
              key={tab}
              className={`px-6 py-2 rounded-full text-sm font-medium ${
                activeTab === tab ? "bg-white text-royalblue-100" : "text-lightgray-200"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {TAB_LABELS[tab]}
            </button>
          ))}
        </div>
      </section>

      {TabContent[activeTab]}
    </div>
  );
};

export default UserManagement;
